<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong>เพิ่มโปรโมชั่น <i class="far fa-plus"></i></strong>
      </div>
      <div class="card-body">
        <div v-if="submit.active==false">
          <div class="col-lg-12 col-sm-12 form-group row" v-if="promotion.languages.data.length!=1">
            <div v-for="language in promotion.languages.data" :key="language.short_name" class="mx-1 text-center">
              <b-button v-if="language.short_name" block variant="outline-info" @click="setLanguage(language.short_name)"
                :class="{active: language.short_name === data.lang }">
                {{ language.name }}
                <span v-bind:class="'flag-icon flag-icon-us'" v-if="covertoLowerCase(language.short_name)=='en'"></span>
                <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(language.short_name)" v-if="covertoLowerCase(language.short_name)!='en'"></span>
              </b-button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">ชื่อโปรโมชั่น<span v-if="data.promotion.lang!=''"> {{data.promotion.lang}}</span>&nbsp;<i
                    class="far fa-bookmark"></i>
                  : </label>
                <input class="form-control" v-model="data.promotion[data.lang].title" type="text" placeholder="กรุณากรอกชื่อโปรโมชั่น">
              </div>
            </div>
          </div>
          <div class="form-group row ">
            <rich-editor class="col-sm-12" v-model="data.promotion[data.lang].description"></rich-editor>
          </div>
          <div class="html-mode-section">
            <c-switch class="mx-1" color="primary" label variant="pill" name="switch3" v-model="hiddenPromotion" :value="1" :uncheckedValue="0" /> 
            <span> Hidden </span>
          </div>
          <div class="form-inline">
            <label for="new_price" class="old-price-label" style="padding-left: 15px; margin: 20px 0;">จากราคาเต็ม: </label>
            <input class="form-control" type="text" placeholder="ราคาเต็ม" v-model="data.promotion[data.lang].old_price">
            <label for="new_price" class="new-price-label">ลดราคาเหลือ: </label>
            <input class="form-control" type="text" placeholder="ราคาที่ลด" v-model="data.promotion[data.lang].new_price">
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label for="name">วันที่สร้าง: </label>
              <datepicker :bootstrap-styling="true" v-model="createdAtPromotion" placeholder="กรุณาคลิกเลือกวันที่สร้าง"></datepicker>
            </div>
            <div class="form-group">
              <label for="name">วันที่หมดอายุ: </label>
              <datepicker :bootstrap-styling="true" v-model="expiredAtPromotion" placeholder="กรุณาคลิกเลือกวันที่หมดอายุ"></datepicker>
            </div>
          </div>
          <div class="col-sm-12 featured-image">
            <div class="form-group row">
              <div class="offset-lg-3 col-lg-6 text-center">
                <label for="ccnumber">รูปตัวอย่าง <i class="far fa-image"></i></label>
                <img v-bind:src="data.image" @error="imageLoadError" class="d-block w-full">
              </div>
            </div>
            <div class="form-group row">
              <div class="offset-lg-2 col-lg-4">
                <button type="button" class="btn btn-outline-primary btn-block w-full" @click="openModal('upload')"><i
                    class="far fa-upload"></i> อัพโหลดรูปจากเครื่อง</button>
              </div>
              <div class="col-lg-4">
                <button type="button" class="btn btn-outline-info btn-block w-full" @click="openModal('link')"><i class="far fa-link"></i>
                  อัพโหลดรูปจากลิงค์</button>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="offset-sm-3 offset-lg-3 col-sm-3 col-lg-3">
              <button class="btn btn-primary w-full" type="submit" @click="submitPromotion"><i class="far fa-clipboard-check"></i>
                ยืนยัน</button>
            </div>
            <div class="col-sm-3 col-lg-3">
              <router-link :to="{ name: 'PromotionList'}"><button class="btn btn-secondary w-full" type="button"><i
                    class="far fa-times-square"></i>
                  ยกเลิก</button></router-link>
            </div>
          </div>
        </div>
        <div v-if="submit.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="promotion.modal.title" ref="model" hide-footer v-model="promotion.modal.active" @ok="promotion.modal.active = false">
      <div v-if="promotion.modal.action=='link'">
        <div class="row">
          <div class="col-md-12">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">URL</span>
              </div>
              <input type="text" class="form-control" v-model="data.image">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
          </div>
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-secondary" block @click="cancleImageLink">ยกเลิกการเปลี่ยนแปลง</b-btn>
          </div>
        </div>
      </div>
      <div v-if="promotion.modal.action=='upload'">
        <div v-if="promotion.img.upload.active==false">
          <div class="custom-file" v-if="promotion.img.crop.active">
            <input type="file" name="image" accept="image/*" class="custom-file-input" @change="setImage" />
            <label class="custom-file-label" for="customFile">Choose file</label>
          </div>
          <div v-if="promotion.img.view.active">
            <div v-if="promotion.img.crop.active" style="width: 100%; height:52.85714%; border: 1px solid gray; display: inline-block;">
              <vue-cropper ref='cropper' :src="promotion.img.view.src" :guides="true" :view-mode="2" drag-mode="crop"
                :initialAspectRatio="100/52.85714" :aspectRatio="100/52.85714" :auto-crop-area="0.5"
                :min-container-width="100" :min-container-height="52.85714" :background="true" :rotatable="true" alt="zeedoc-img-promotion"
                :img-style="{ 'width': '100%', 'height': '52.85714%' }">
              </vue-cropper>
            </div>
            <div>
              <div v-if="!promotion.img.crop.active">
                <label for="ccnumber">ภาพที่จะแสดงในโปรโมชั่น <i class="far fa-image"></i></label>
                <img :src="promotion.img.crop.src" style="width: 100%; height: 52.85714%; border: 1px solid gray" alt="ตัวอย่างรูปที่จะนำเข้า" />
                <hr>
              </div>
            </div>
          </div>
          <div class="row" v-if="promotion.img.crop.active && promotion.img.view.src">
            <div class="offset-lg-2 col-lg-8">
              <br />
              <b-btn @click="cropImage" variant="primary" block>เลือกภาพนี้</b-btn>
            </div>
          </div>
          <div class="row" v-if="!promotion.img.crop.active && promotion.img.crop.src">
            <div class="col-lg-6">
              <b-btn variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
            </div>
            <div class="col-lg-6">
              <b-btn @click="cancleImage" variant="secondary" block>ยกเลิกภาพ</b-btn>
            </div>
          </div>
        </div>
        <div v-if="promotion.img.upload.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueCropper from 'vue-cropperjs'
  import RichEditor from '@/components/richEditor'
  import Helper from '@/shared/helper'
  import { Switch as cSwitch } from '@coreui/vue'
  import Datepicker from 'vuejs-datepicker'

  export default {
    components: {
      Datepicker,
      VueCropper,
      RichEditor,
      cSwitch
    },
    mixins: [Helper],
    data() {
      return {
        hiddenPromotion: 0,
        createdAtPromotion: null,
        expiredAtPromotion: null,
        load: 0,
        submit: {
          active: false,
          error: false
        },
        no_image: {
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        promotion: {
          id: parseInt(this.$route.params.id),
          languages: {
            count: 1,
            data: []
          },
          img: {
            upload: {
              active: false
            },
            view: {
              src: '',
              active: false
            },
            crop: {
              src: '',
              active: false
            }
          },
          modal: {
            title: '',
            action: '',
            active: false
          },
        },
        authorization: 'Bearer ' + localStorage.getItem('z_token'),
        data: {
          page: 0,
          per_page: 0,
          lang: 'th',
          session: [],
          image: '',
          promotion: {
            th: {
              id: '',
              title: '',
              description: '',
              lang: '',
              new_price: '',
              old_price: '',
              created_at: ''
            }
          }
        },
        options: null
      }
    },
    methods: {
      covertoLowerCase(title) {
        if (title && title != '') {
          return title.toLowerCase()
        } else {
          return title
        }
      },
      openModal(action) {
        this.promotion.img.view.active = false
        this.promotion.modal.action = action
        this.promotion.img.crop.active = true
        if (action == 'upload') {
          this.promotion.img.view.src = null
          this.promotion.modal.title = 'อัพโหลดรูปจากเครื่อง'
          this.promotion.modal.active = true
        } else if (action == 'link') {
          this.promotion.modal.title = 'อัพโหลดรูปจากลิงค์'
          this.promotion.modal.active = true
        }
      },
      setLanguage(language) {
        this.data.lang = language
      },
      setImage(e) {
        const file = e.target.files[0]
        this.promotion.img.view.active = true
        if (!file.type.includes('image/')) {
          alert('Please select an image file')
          return
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.promotion.img.view.src = event.target.result
            this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
      },
      submitPromotion() {
        if (this.promotion.id != '' && this.promotion.id) {
          this.checkUpdatePromotion()
        } else {
          this.checkPromotion()
        }
      },
      checkPromotion() {
        this.data.session = []
        let item = null
        let isVal = false
        let emtpyCount = 0
        let data = []
        this.startLoad(this.promotion.languages.count)

        if (!this.data.image || this.data.image === '') {
          this.data.image = this.no_image.src
        }

        for (item in this.data.promotion) {
          if (this.data.promotion[item].title != '' && this.data.promotion[item].title) {
            if (isVal) {
              this.data.session[item] = this.data.promotion[item]
            } else {
              if (this.data.promotion[item].title.length > 5) {
                this.submit.active = true
                this.createPromotion({
                  'title': this.data.promotion[item].title,
                  'description': this.data.promotion[item].description,
                  'image': this.data.image,
                  'locale': item,
                  'new_price': this.data.promotion[item].new_price,
                  'old_price': this.data.promotion[item].old_price,
                  'hidden': this.hiddenPromotion,
                  'created_at': this.createdAtPromotion,
                  'expired_at': this.expiredAtPromotion
                }, true)
              } else {
                // this.checkLoad()
                alert("กรุณากรอกชื่อของโปรโมชั่นที่มีความยามมากกว่า5ตัวอักษร (" + item + ")")
              }
            }
            isVal = true
          } else {
            this.checkLoad()
            emtpyCount = emtpyCount + 1
            if (emtpyCount == this.promotion.languages.count) {
              this.submit.active = false
              alert('กรุณาใส่ข้อมูลของโปรโมชั่น')
            }
          }
        }
      },
      imageLoadError(event) {
        this.data.image = ''
        event.target.src = this.no_image.src
      },
      createPromotion(data, isfunc) {
        this.$http.post(process.env.VUE_APP_API_URL + 'api/v1/promotion', data, {
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          let item = null
          this.checkLoad()
          if (isfunc == true) {
            for (item in this.data.session) {
              this.createPromotion({
                'title': this.data.session[item].title,
                'description': this.data.session[item].description,
                'image': this.data.image,
                'id': response.body.json.promotion.id,
                'locale': item,
                'new_price': this.data.session[item].new_price,
                'old_price': this.data.session[item].old_price,
                'hidden': this.hiddenPromotion,
                'created_at': this.createdAtPromotion,
                'expired_at': this.expiredAtPromotion
              }, false);
            }
          }
          if (this.load == 0) {
            alert('โปรโมชั่นสร้างเรียบร้อย');
            this.$router.push({
              name: 'PromotionList'
            })
          }
        }).catch(function (error) {
          if (this.submit.error == false) {
            this.submit.error = true
            console.log(error)
            alert('ไม่สามารถสร้างโปรโมชั่นได้ กรุณากรอกชื่อของโปรโมชั่น!');
            this.$router.push({
              name: 'PromotionList'
            })
          }
        })
      },
      async updatePromotion(data) {
        try {
          await this.$http.put(process.env.VUE_APP_API_URL + 'api/v1/promotion/' + this.promotion.id, data, {
            headers: {
              Authorization: this.authorization
            }
          })
        } catch (e) {
          if (this.submit.error == false) {
            this.submit.error = true
            console.log(e)
            alert('ไม่สามารถสร้างโปรโมชั่นได้ กรุณากรอกชื่อของโปรโมชั่น!')
            this.$router.push({
              name: 'PromotionList'
            })
          }
        }
        this.checkLoad()
      },
      async checkUpdatePromotion() {
        let item = null
        let emtpyCount = 0
        this.startLoad(this.promotion.languages.count)
        for (item in this.data.promotion) {
          if (this.data.promotion[item].title != '' && this.data.promotion[item].title) {
            if (this.data.promotion[item].title.length > 5) {
              this.submit.active = true
              await this.updatePromotion({
                'id': this.data.promotion[item].id,
                'title': this.data.promotion[item].title,
                'description': this.data.promotion[item].description,
                'image': this.data.image,
                'locale': item,
                'new_price': this.data.promotion[item].new_price,
                'old_price': this.data.promotion[item].old_price,
                'hidden': this.hiddenPromotion,
                'created_at': this.createdAtPromotion,
                'expired_at': this.expiredAtPromotion
              })
            } else {
              this.checkLoad()
              alert("กรุณากรอกชื่อของโปรโมชั่นที่มีความยามมากกว่า5ตัวอักษร (" + item + ")")
            }
          } else {
            this.checkLoad()
            emtpyCount = emtpyCount + 1
            if (emtpyCount == this.promotion.languages.count) {
              this.submit.active = false
              alert('กรุณาใส่ข้อมูลของโปรโมชั่น')
            }
          }
        }
        if (this.load == 0) {
          alert('โปรโมชั่นอัพเดทเรียบร้อย')
          this.$router.push({
            name: 'PromotionList'
          })
        }
      },
      async submitImage() {
        if (this.promotion.img.crop.src != '' && this.promotion.img.crop.src) {
          this.promotion.img.upload.active = true
          try {
            this.data.image = await this.uploadImageDataUrl(this.promotion.img.crop.src, 'promotion.jpg')
            this.promotion.img.upload.active = false
            this.cancleImageLink
            this.$refs.model.hide()
          } catch (error) {
            this.promotion.img.upload.active = false
            alert('คุณใส่ชนิดหรือรูปแบบของรูปภาพไม่ถูกต้อง!')
            this.cancleImageLink
            this.$refs.model.hide()
          }
        } else {
          this.promotion.img.upload.active = false
          this.$refs.model.hide()
        }
      },
      cropImage() {
        this.promotion.img.crop.active = false
        this.promotion.img.crop.src = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      },
      cancleImage() {
        this.promotion.img.view.src = null
        this.promotion.img.view.active = false
        this.promotion.img.crop.active = true
        this.promotion.img.crop.src = null
      },
      cancleImageLink() {
        this.promotion.img.view.active = false
        this.promotion.img.crop.active = true
        this.promotion.img.crop.src = null
        this.data.image = ''
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      getPromotionByID(id, lang) {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/promotion/' + id, {
          params: {
            lang: lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          if (response.body.json) {
            this.data.promotion[response.body.json.locale].id = response.body.json.id
            this.data.promotion[response.body.json.locale].title = response.body.json.title
            this.data.promotion[response.body.json.locale].description = response.body.json.description
            this.data.promotion[response.body.json.locale].new_price = response.body.json.new_price
            this.data.promotion[response.body.json.locale].old_price = response.body.json.old_price
            this.data.promotion[response.body.json.locale].created_at = response.body.json.created_at
            this.data.promotion[response.body.json.locale].expired_at = response.body.json.expired_at
            this.data.promotion[response.body.json.locale].hidden = response.body.json.hidden
            this.hiddenPromotion = response.body.json.hidden
            this.createdAtPromotion = response.body.json.created_at
            this.expiredAtPromotion = response.body.json.expired_at
            if (response.body.json.image && response.body.json.image != '') {
              this.data.image = response.body.json.image
            } else {
              this.data.image = this.no_image.src
            }
          }
        }, response => {
          this.checkLoad()
        })
      },
      getLanguages() {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/languages', {
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          const numLanguage = response.body.json.length
          let item = null
          if (numLanguage >= 1) {
            this.promotion.languages.count = response.body.json.length
            this.promotion.languages.data = response.body.json
            this.startLoad(this.promotion.languages.count + 1)
            for (item in this.promotion.languages.data) {
              this.data.promotion[this.promotion.languages.data[item].short_name] = {
                title: '',
                image: '',
                description: '',
                lang: '',
                new_price: '',
                old_price: '',
                created_at: ''
              }
              if (Number.isInteger(this.promotion.id)) {
                this.getPromotionByID(this.promotion.id, this.promotion.languages.data[item].short_name)
              }
            }
            this.setLanguage(this.promotion.languages.data[0].short_name)
          }
        }, response => {
          this.failLoad()
        })
      }
    },
    async mounted() {
      this.options = await this.getOptions()
      this.getLanguages()
    }
  }

</script>
<style lang="scss">
  .ql-editor {
    height: 20rem !important;
  }

  .new-price-label {
    padding: 0 20px;
  }

  .old-price-label {
    padding: 0 20px 0 40px;
  }

  .featured-image {
    margin-top: 40px;
  }

</style>
